module.exports = "<div>\n  <app-new-page [pageTitle]=\"page.title\" [pageSlug]=\"page.slug\"></app-new-page>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/event/live-streaming/live-streaming.html
// module id = ../../../../../src/app/event/live-streaming/live-streaming.html
// module chunks = main